import '../style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { CorporateAccountOpenProfileDetailsPages, useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';
import { Caption } from 'views/mutual/caption';
import { MultiCheckInput } from 'views/templates/module/checkInput';
import { FormContentHeader, FormType } from 'views/templates/module/contentHeader';
import { useInvestorCategoryInfo } from './hooks';
import { TemplateProps } from '../common';
import { useCustomLocationName } from 'views/mutual/location/hooks';

export type InvestorCategoryInfoProps = {
  formik: any;
  porps: any;
};

export const InvestorCategoryInfoWrapper = () => {
  return <InvestorCategoryInfo {...useInvestorCategoryInfo({ isUpdate: false })} />;
};

export const InvestorCategoryInfo = ({ formik, porps, isUpdate }: InvestorCategoryInfoProps & TemplateProps) => {
  const { setAccountOpenProfileDetailsPageType } = useCorporateAccountOpenProfileDetailsPageTypeStore();

  useCustomLocationName('口座開設申込みフォーム');
  return (
    <form onSubmit={formik.handleSubmit} className="accountOpenTemplate">
      {!isUpdate && <Caption label="投資家区分情報" />}
      <div className="accountOpenTemplate_input">
        <FormContentHeader label="以下のうち、貴社が該当するものはすべてチェックしてください" formType={FormType.Required} />
        <div className="accountOpenTemplate_input_check">
          <MultiCheckInput {...porps} />
        </div>
      </div>
      {!isUpdate && (
        <div className="accountOpenTemplate_button">
          <Button type={ButtonType.Submit} label="次へ" buttonFill={ButtonFill.black} buttonSize={ButtonSize.medium}/>
          <Button
            label="前の画面に戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.small}
            onClick={() => setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.rulerInfo)}
          />
        </div>
      )}
    </form>
  );
};
